import GeneralService from "./GeneralService";
import { ValidationRun } from "../model_gen/finetuning";

export class ValidationService {
  public static getValidationRequests(
    finetuneRunId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/validation/${finetuneRunId}/requests`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getValidationRunsByFinetuneRunId(
    finetuneRunId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/validation/${finetuneRunId}/runs`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static runValidation(
    finetuneRunId: string,
    payload: { model: string; intentId?: string },
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/validation/${finetuneRunId}/run`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static getValidationRuns(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/validation/",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deleteValidationRun(
    validationRun: Partial<ValidationRun>,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.delete(
      `/validation/${validationRun.id}`,
      JSON.stringify(validationRun),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
